export const siteConfig = {
  NAME: 'Trans*Creative',
  URL: 'https://tcreative.fi',
  NETLIFY_IDENTITY_URL: 'https://tcreative.fi',
  CONTENTFUL_SPACE_ID: '8xc8ns12po95',
};
